import { connect } from 'react-redux';
import HRulerS from './h_ruler';
import VRulerS from './v_ruler';

const mapStateToPropsH = ({
  canvas: {
    posX, centerX, dpi, width
  }
}) => ({
  pos: posX,
  center: centerX,
  maxLastTick: width,
  dpi
});

const mapStateToPropsV = ({
  canvas: {
    posY, centerY, dpi, height
  }
}) => ({
  pos: posY,
  center: centerY,
  maxLastTick: height,
  dpi
});

export const HRuler = connect(mapStateToPropsH)(HRulerS);
export const VRuler = connect(mapStateToPropsV)(VRulerS);

// export default connect(mapStateToProps)(Ruler);
